module.exports = __webpack_public_path__ + "static/media/06a.cf3cca0b.png";